/*
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-08-30 14:48:13
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-09-08 14:22:45
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import CalendarLocale from '../../vc-picker/locale/phi';
import TimePickerLocale from '../../time-picker/locale/phi'; // 统一合并为完整的 Locale

var locale = {
    lang: _extends({
        placeholder: 'Mangyaring pumili ng petsa',
        yearPlaceholder: 'Mangyaring pumili ng isang taon',
        quarterPlaceholder: 'Mangyaring pumili ng isang quarter',
        monthPlaceholder: 'Mangyaring pumili ng buwan',
        weekPlaceholder: 'Mangyaring pumili ng isang linggo',
        rangePlaceholder: ['petsa ng pagsisimula', 'petsa ng pagtatapos'],
        rangeYearPlaceholder: ['simula taon', 'pagtatapos ng taon'],
        rangeMonthPlaceholder: ['simula ng buwan', 'pagtatapos ng buwan'],
        rangeQuarterPlaceholder: ['simula quarter', 'pagtatapos ng quarter'],
        rangeWeekPlaceholder: ['simula linggo', 'pagtatapos ng linggo']
    }, CalendarLocale),
    timePickerLocale: _extends({}, TimePickerLocale)
}; // should add whitespace between char in Button

locale.lang.ok = '确定'; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;